import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { createEntity, getEntity, reset, updateEntity } from './contact-rms.reducer';

export const ContactRmsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const contactRmsEntity = useAppSelector(state => state.contactRms.entity);
  const loading = useAppSelector(state => state.contactRms.loading);
  const updating = useAppSelector(state => state.contactRms.updating);
  const updateSuccess = useAppSelector(state => state.contactRms.updateSuccess);

  const handleClose = () => {
    navigate('/contact-rms');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.kvk !== undefined && typeof values.kvk !== 'number') {
      values.kvk = Number(values.kvk);
    }
    if (values.phoneNumber !== undefined && typeof values.phoneNumber !== 'number') {
      values.phoneNumber = Number(values.phoneNumber);
    }

    const entity = {
      ...contactRmsEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...contactRmsEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.contactRms.home.createOrEditLabel" data-cy="ContactRmsCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.contactRms.home.createOrEditLabel">
              Create or edit a ContactRms
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="contact-rms-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.contactRms.firstName')}
                id="contact-rms-firstName"
                name="firstName"
                data-cy="firstName"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.contactRms.lastName')}
                id="contact-rms-lastName"
                name="lastName"
                data-cy="lastName"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.contactRms.company')}
                id="contact-rms-company"
                name="company"
                data-cy="company"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.contactRms.kvk')}
                id="contact-rms-kvk"
                name="kvk"
                data-cy="kvk"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.contactRms.email')}
                id="contact-rms-email"
                name="email"
                data-cy="email"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.contactRms.phoneNumber')}
                id="contact-rms-phoneNumber"
                name="phoneNumber"
                data-cy="phoneNumber"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.contactRms.message')}
                id="contact-rms-message"
                name="message"
                data-cy="message"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.contactRms.fileContactPath')}
                id="contact-rms-fileContactPath"
                name="fileContactPath"
                data-cy="fileContactPath"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.contactRms.consent')}
                id="contact-rms-consent"
                name="consent"
                data-cy="consent"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.contactRms.checkSendEmail')}
                id="contact-rms-checkSendEmail"
                name="checkSendEmail"
                data-cy="checkSendEmail"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.contactRms.type')}
                id="contact-rms-type"
                name="type"
                data-cy="type"
                type="text"
              />
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/contact-rms"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ContactRmsUpdate;
